export enum AggregationType {
    sum,
    average,
    averageWeighted,
}

export class AggregationMethod {
    public type: AggregationType;
    public columnIndex: number;
}